import React from 'react'
import { Link } from '@fs/zion-router'
import { Row, colors, Skeleton } from '@fs/zion-ui'
import { ArrowCaret } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { useDynamicLinkContext } from '../DynamicLinksProvider'
import { buildUrl } from '../footerHelperFunctions'

const linkCss = css`
  color: ${colors.transparent.gray70} !important; // needed because of isGray and noLinkStyles conflicting

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`
const moreButton = css`
  display: flex;
  align-items: center;
  color: ${colors.transparent.gray70};
  background: none;
  border: none;
  font-size: 14px;
  margin-inline-start: -5px;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
  span {
    margin-inline-end: 8px;
  }
`

export default function MinNavLinks({
  viewWidth,
  handleExpandClick,
  showArabicExperience,
  external,
  hideMoreButton,
  ...props
}) {
  const { t } = useTranslation()
  const { navigation } = useDynamicLinkContext()

  return (
    // Without an aria-label, this is just listed as "navigation" to screenreaders (now lists as "Footer navigation")
    <nav aria-label={t('nav.footer', 'Footer')} {...props}>
      <Row wrap alignX={viewWidth === 'mobile' ? 'center' : 'start'} alignItemsY="middle">
        <Row wrap growX alignX={viewWidth === 'mobile' ? 'center' : 'start'} alignItemsY="middle">
          {navigation?.condensedFooter?.map(({ show, id, url, linkName, text, ...linkProps }) =>
            show === false ? null : (
              <Link
                key={id || linkName}
                className={linkCss}
                to={buildUrl(url, external)}
                linkName={linkName}
                noLinkStyles
                isGray
                wayfinding
                external
                {...linkProps}
              >
                {text}
              </Link>
            )
          ) || (
            <Row>
              <Skeleton.Paragraph maxWidth={72} />
              <Skeleton.Paragraph maxWidth={72} />
              <Skeleton.Paragraph maxWidth={72} />
            </Row>
          )}
          {!showArabicExperience && !hideMoreButton && (
            <Row alignItemsY="middle">
              |
              <Row alignY="middle" gutters="nano">
                <button
                  className={moreButton}
                  type="button"
                  onClick={handleExpandClick}
                  name="footer_more"
                  aria-label={t('nav.links.more.aria-label', 'more links')}
                >
                  <span>{t('common-ui:show-more.info.abbr', 'More')}</span>
                  <ArrowCaret background={colors.transparent.gray70} color="white" size="xs" direction="down" />
                </button>
              </Row>
            </Row>
          )}
        </Row>
      </Row>
    </nav>
  )
}
